import type { RouteRecordRaw } from 'vue-router'

const merchantRoutes: RouteRecordRaw[] = [
  {
    path: '/merchant/rules/points',
    name: 'MerchantPointsRules',
    component: () => import('@/views/merchant/points/PointsRule.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: ['merchant:config:view'],
      title: '积分规则',
    },
  },
  {
    path: '/merchant/rules/members',
    name: 'MerchantMemberRules',
    component: () => import('@/views/merchant/levels/LevelList.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: ['merchant:config:view'],
      title: '会员规则',
    },
  },
  {
    path: '/merchant/rules/discount',
    name: 'MerchantDiscountRules',
    component: () => import('@/views/merchant/rules/DiscountRule.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: ['merchant:config:view'],
      title: '折扣规则',
    },
  },
  {
    path: '/merchant/rules/wechat',
    name: 'MerchantWeChatRules',
    component: () => import('@/views/merchant/rules/WeChatConfig.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: ['merchant:config:view'],
      title: '微信配置',
    },
  },
  {
    path: '/merchant/shops',
    name: 'MerchantShops',
    component: () => import('@/views/merchant/shops/ShopList.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: ['merchant:shop:view'],
      title: '分支组织管理',
    },
  },
  {
    path: '/merchant/employees',
    name: 'MerchantEmployees',
    component: () => import('@/views/merchant/employees/EmployeeList.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: ['merchant:employee:view'],
      title: '员工管理',
    },
  },
  {
    path: '/merchant/members',
    name: 'MerchantMembers',
    component: () => import('@/views/merchant/members/MemberList.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: ['merchant:member:view'],
      title: '会员管理',
    },
  },
  {
    path: '/merchant/points/records',
    name: 'MerchantPointRecords',
    component: () => import('@/views/merchant/points/PointsRecords.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: ['merchant:points:view'],
      title: '积分管理',
    },
  },
  {
    path: '/merchant/mall/products',
    name: 'MerchantMallProducts',
    component: () => import('@/views/merchant/mall/ProductList.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: ['merchant:mall:view'],
      title: '商品管理',
    },
  },
  {
    path: '/merchant/mall/orders',
    name: 'MerchantMallOrders',
    component: () => import('@/views/merchant/mall/OrderList.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: ['merchant:mall:view'],
      title: '订单管理',
    },
  },
{
  path: '/merchant/sms',
  name: 'MerchantSms',
  component: () => import('@/views/merchant/sms/SmsConfig.vue'),
  meta: {
    requiresAuth: true,
    requiredPermissions: ['merchant:sms:view'],
    requiredModules: ['module_sms'],
    title: '网关配置',
  },
},
{
  path: '/merchant/sms/batch',
  name: 'MerchantSmsBatch',
  component: () => import('@/views/merchant/sms/SmsBatchSend.vue'),
  meta: {
    requiresAuth: true,
    requiredPermissions: ['merchant:sms:view'],
    requiredModules: ['module_sms'],
    title: '批量发送',
  },
},
{
  path: '/merchant/children',
  name: 'MerchantChildren',
  component: () => import('@/views/merchant/children/ChildList.vue'),
  meta: {
    requiresAuth: true,
    requiredPermissions: ['merchant:child:view'],
    requiredModules: ['module_child'],
    title: '孩子管理',
  },
},
{
  path: '/merchant/subject-docs',
  name: 'MerchantSubjectDocs',
  component: () => import('@/views/merchant/subject-docs/SubjectDocumentManage.vue'),
  meta: {
    requiresAuth: true,
    requiredPermissions: ['merchant:subject-doc:view'],
    requiredModules: ['module_subject_document'],
    title: '学科资料管理',
  },
},
{
  path: '/merchant/service-appointments',
  name: 'MerchantServiceAppointments',
  component: () => import('@/views/merchant/services/ServiceAppointment.vue'),
  meta: {
    requiresAuth: true,
    requiredPermissions: ['merchant:service:view'],
    requiredModules: ['module_service_appointment'],
    title: '服务预约管理',
  },
},
{
  path: '/merchant/outstanding-students',
  name: 'MerchantOutstandingStudents',
  component: () => import('@/views/merchant/outstanding/OutstandingStudent.vue'),
  meta: {
    requiresAuth: true,
    requiredPermissions: ['merchant:outstanding:view'],
    requiredModules: ['module_outstanding_student'],
    title: '优秀学员管理',
  },
},
{
  path: '/merchant/news',
  name: 'MerchantNews',
  component: () => import('@/views/merchant/news/NewsList.vue'),
  meta: {
    requiresAuth: true,
    requiredPermissions: ['merchant:news:view'],
    requiredModules: ['module_news'],
    title: '最新动态管理',
  },
},
{
  path: '/merchant/recommended-courses',
  name: 'MerchantRecommendedCourses',
  component: () => import('@/views/merchant/recommended/RecommendedCourse.vue'),
  meta: {
    requiresAuth: true,
    requiredPermissions: ['merchant:recommended:view'],
    requiredModules: ['module_recommended_courses'],
    title: '推荐课程管理',
  },
},
{
  path: '/merchant/home-secondary-pages',
  name: 'MerchantHomeSecondaryPages',
  component: () => import('@/views/merchant/rules/HomeSecondaryPages.vue'),
  meta: {
    requiresAuth: true,
    requiredPermissions: ['merchant:config:view'],
    requiredModules: ['module_home_management'],
    title: '首页管理',
  },
},
{
  path: '/merchant/education-bookings',
  name: 'MerchantEducationBookings',
  component: () => import('@/views/merchant/services/EducationBooking.vue'),
  meta: {
    requiresAuth: true,
    requiredPermissions: ['merchant:service:view'],
    requiredModules: ['module_education_booking'],
    title: '学校预约管理',
  },
},
{
  path: '/merchant/lecture-bookings',
  name: 'MerchantLectureBookings',
  component: () => import('@/views/merchant/services/LectureBooking.vue'),
  meta: {
    requiresAuth: true,
    requiredPermissions: ['merchant:service:view'],
    requiredModules: ['module_lecture_booking'],
    title: '讲座报名管理',
  },
},
{
  path: '/merchant/higher-education-bookings',
  name: 'MerchantHigherEducationBookings',
  component: () => import('@/views/merchant/services/HigherEducationBooking.vue'),
  meta: {
    requiresAuth: true,
    requiredPermissions: ['merchant:service:view'],
    requiredModules: ['module_higher_education_booking'],
    title: '升学规划预约管理',
  },
},
{
  path: '/merchant/family-education-forums',
  name: 'MerchantFamilyEducationForums',
  component: () => import('@/views/merchant/services/FamilyEducationForum.vue'),
  meta: {
    requiresAuth: true,
    requiredPermissions: ['merchant:config:view'],
    requiredModules: ['module_forum_management'],
    title: '论坛管理',
  },
},
{
  path: '/merchant/home-carousels',
  name: 'MerchantHomeCarousels',
  component: () => import('@/views/merchant/rules/HomeCarouselManagement.vue'),
  meta: {
    requiresAuth: true,
    requiredPermissions: ['merchant:config:view'],
    requiredModules: ['module_home_carousel'],
    title: '轮播图管理',
  },
},
]

export default merchantRoutes
